import {createContext} from "react";

export const ParticipationFormContext = createContext({
    nextStage: ()=>{}
})